export default __webpack_public_path__ + "static/media/ArugulaSalad.cd3d0e2a.jpg";